// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
// @flow

import keyMirror from 'utils/key_mirror';

export default keyMirror({
    MY_PREFERENCES_REQUEST: null,
    MY_PREFERENCES_SUCCESS: null,
    MY_PREFERENCES_FAILURE: null,

    SAVE_PREFERENCES_REQUEST: null,
    SAVE_PREFERENCES_SUCCESS: null,
    SAVE_PREFERENCES_FAILURE: null,

    DELETE_PREFERENCES_REQUEST: null,
    DELETE_PREFERENCES_SUCCESS: null,
    DELETE_PREFERENCES_FAILURE: null,

    RECEIVED_PREFERENCES: null,
    RECEIVED_ALL_PREFERENCES: null,
    DELETED_PREFERENCES: null,
});
